import React from 'react'
const Shimmer = () => {
    

  return (
    <div className={'m-1 grid grid-cols-3'}>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
        <div className="m-2 w-96 h-64 bg-slate-200 rounded-lg"></div>
    </div>
  )
}

export default Shimmer